<!--<ng-template #imageExists>-->
<div [style.display]="fileUploads.length > 0 ? 'block' : 'none'">
  <div>
    <div class="image-div" *ngFor="let fileUpload of fileUploads; let i = index">
      <div class="overlay" *ngIf="fileUpload != null && fileUpload.uploading; else imageUploaded">
        <p class="upload-percentage">{{ percentage }}%</p>
      </div>
      <ng-template #imageUploaded>
        <div>
          <img class="delete-img" src="assets/cancel-icon.svg" (click)="deleteFile(i)" />
        </div>
      </ng-template>

      <img class="uploaded-image" [src]="fileUpload.localURL" />
    </div>
  </div>
</div>
<!--</ng-template>-->


<div [style.display]="allowMulti || fileUploads.length == 0 ? 'block' : 'none'">
  <div class="dropzone" appDragAndDrop (fileDropped)="uploadFile($event)">
    <input type="file" #fileDropRef id="fileDropRef" (change)="fileSelected($event)" />
    <div class="upload-icon"><i class="bi bi-upload"></i></div>
    <p i18n>Drag a file to this area to upload or click to browse.</p>
  </div>
</div>

<div class="invalid-feedback-style" *ngIf="this.errorMessage">{{ errorMessage }}</div>

